import { Component, Input, Output, EventEmitter, TemplateRef, ViewChild } from "@angular/core";
import { SegmentedControlSize } from "../types/segmented-control.types";

@Component({
  selector: "ds-segmented-option",
  templateUrl: "./ds-segmented-option.component.html",
  styleUrls: ["./ds-segmented-option.component.scss"],
})
export class DsSegmentedOptionComponent {
  @Input() label!: string;
  @Input() disabled = false;
  @Input() counter?: number | string;
  @Input() icon = "";
  @Input() dsIcon = "";
  // Keep the existing public API while acknowledging its native-event name.
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() select = new EventEmitter<void>();

  @ViewChild("templateButton", { static: true }) templateButton!: TemplateRef<any>;
  @ViewChild("content", { static: true }) content!: TemplateRef<any>;

  /** Set by the parent ds-segmented-control to size every option consistently. */
  size: SegmentedControlSize = "lg";
  active: boolean;
  constructor() {}
}
